import { getController } from '@/services/service'

const url = 'records'

export const recordService = {
	...getController<Api.Record, Api.RecordPostInput>(url),
}

export default recordService
